var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJackpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.483 0.0287525C2.83264 -0.0571256 3.07324 0.0578485 3.74928 0.261034C3.84497 0.289792 3.9416 0.326302 4.04052 0.34031C4.26132 0.371572 4.67962 0.385353 4.97407 0.303965C5.47228 0.166252 5.51375 -0.0172895 6.17804 0.0745479C6.84232 0.166385 6.55175 1.0381 6.09505 2.00149C5.63836 2.96488 4.89648 2.91883 4.26821 2.91883C3.39626 2.91883 3.10577 2.46024 2.73211 2.13912C2.35845 1.81799 1.86436 0.180705 2.483 0.0287525Z",
    fill: "white",
    fillOpacity: 0.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93156 9.3814C9.96951 7.78833 8.58878 4.85378 7.27577 3.26645C7.07746 3.0267 6.74216 2.96749 6.45483 3.08686C4.92758 3.72138 3.8838 3.78496 2.26526 3.07571C2.00391 2.96118 1.69463 2.99216 1.48761 3.18853C-0.566463 5.13688 -0.0635215 7.36317 0.478783 8.27233C1.25177 9.3646 3.62451 11.1156 6.93156 9.3814Z",
    fill: "white",
    fillOpacity: 0.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/jackpot.40093d1324561ce183f6dd78c4980f01.svg";
export { ForwardRef as ReactComponent };